import HomeComponent from './Home.component';

export * from "./Home.component";
export default HomeComponent;
